import { render, staticRenderFns } from "./HotelDetailDrawer.vue?vue&type=template&id=b987b62e&scoped=true"
import script from "./HotelDetailDrawer.vue?vue&type=script&lang=js"
export * from "./HotelDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./HotelDetailDrawer.vue?vue&type=style&index=0&id=b987b62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b987b62e",
  null
  
)

export default component.exports